import {
    KEY_CODE_ARROW_DOWN,
    KEY_CODE_ARROW_LEFT,
    KEY_CODE_ARROW_RIGHT,
    KEY_CODE_ARROW_UP,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import { VIEW_BOX_MOVE_AMOUNT } from '%paysera_seat_selection_integration/js/seatings/redux/config/constants';
import handleMoveViewBox from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/reducers/handleMoveViewBox';

export default (state, { payload }) => {
    switch (payload) {
        case KEY_CODE_ARROW_UP:
            return handleMoveViewBox(state, { payload: { x: 0, y: -VIEW_BOX_MOVE_AMOUNT } });
        case KEY_CODE_ARROW_DOWN:
            return handleMoveViewBox(state, { payload: { x: 0, y: VIEW_BOX_MOVE_AMOUNT } });
        case KEY_CODE_ARROW_LEFT:
            return handleMoveViewBox(state, { payload: { x: -VIEW_BOX_MOVE_AMOUNT, y: 0 } });
        case KEY_CODE_ARROW_RIGHT:
            return handleMoveViewBox(state, { payload: { x: VIEW_BOX_MOVE_AMOUNT, y: 0 } });
        default:
            return state;
    }
};
